export const NativeEventEmitterMobileOsTypesEnum = {
    ANDROID: 'android',
    IOS: 'ios',
    DEFAULT: 'default',
};
